import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import { EmployeeHttpClient } from 'src/app/shared/flight-log-api/employees/employee-client.service';
import { AppState } from 'src/store';
import { EmployeeEntity } from 'src/store/employee/employee.model';
import { selectEmployeeById } from 'src/store/employee/employee.selectors';
import { UserViewModel } from 'src/view-models/user-view-model';
import { AutcompleteComponentBase } from '../autocomplete-helper/autocomplete-helper.component';

@Component({
  selector: 'fl-employee-autocomplete',
  template: ` <fl-autocomplete-helper [config]="helperConfig"></fl-autocomplete-helper> `,
  styleUrls: ['./employee-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: EmployeeAutocompleteComponent,
      multi: true,
    },
  ],
})
export class EmployeeAutocompleteComponent extends AutcompleteComponentBase<
  EmployeeEntity,
  string
> {
  public placeholder = 'Employee';
  public disableFn = undefined;
  @Input() public allCompanies: boolean;
  @Input() public includeDispatched: boolean;

  public selectControlValue = (option: EmployeeEntity) => option.id;
  public optionDisplayFn = (option: EmployeeEntity) =>
    `${option.firstName} ${option.lastName} (${option.employeeId})`;
  public getSingleOption(value: string): Observable<EmployeeEntity | undefined> {
    return this._store
      .select(selectEmployeeById(value))
      .pipe(switchMap((e) => (e != null ? of(e) : this._employees.getById(value))));
  }
  public getManyOptions(userInput: string): Observable<EmployeeEntity[]> {
    return this._employees.getAll({
      $top: 50,
      includeDispatched: this.includeDispatched,
      companyId: this.allCompanies === true ? undefined : this._user.companyId,
      searchTerm: userInput,
    });
  }

  constructor(
    private _employees: EmployeeHttpClient,
    private _store: Store<AppState>,
    @Inject(USER) private _user: UserViewModel,
  ) {
    super();
  }
}
